import { createFeatureSelector, createSelector } from '@ngrx/store';

import { StripePurchaseEnum } from '../../enums/monetization';
import { PaywallInformation } from '../models/monetization.model';
import { State } from '../reducers/monetization.reducer';
import { monetizationFeatureKey } from '../reducers/monetization.reducer';

export const selectMonetizationFeature = createFeatureSelector<State>(monetizationFeatureKey);

export const selectIsEnabled = createSelector(selectMonetizationFeature, (state) => state.isEnabled);

export const selectVirtualCurrency = createSelector(selectMonetizationFeature, (state) => state.virtualCurrency);

export const selectPrimarySubscriptionIsEnabled = createSelector(
  selectMonetizationFeature,
  (state) => state.primarySubscriptionIsEnabled
);

export const selectPhoneAndEmailPurchaseEnabled = createSelector(
  selectMonetizationFeature,
  (state) => state.phoneAndEmailPurchaseEnabled
);

export const selectPrimarySubscriptionAccessAlias = createSelector(
  selectMonetizationFeature,
  (state) => state.primarySubscriptionAccessAlias
);

export const selectPrimarySubscriptionIsActive = createSelector(
  selectMonetizationFeature,
  (state) => state.primarySubscriptionIsActive
);

export const selectPrimarySubscriptionName = createSelector(
  selectMonetizationFeature,
  (state) => state.primarySubscriptionName
);

export const selectPrimarySubscriptionPlatformProductIdentifier = createSelector(
  selectMonetizationFeature,
  (state) => state.primarySubscriptionPlatformProductIdentifier
);

export const selectPrimarySubscriptionPaywallInformation = createSelector(
  selectMonetizationFeature,
  (state): PaywallInformation => ({
    description: state.primarySubscriptionDescription,
    name: state.primarySubscriptionName,
    priceText: state.primarySubscriptionPriceText,
    product: state.primarySubscriptionPurchasesStoreProduct,
    type: StripePurchaseEnum.Subscription,
    webPriceId: state.primarySubscriptionWebPriceId
  })
);

export const selectStoreProductPaywallInformation = createSelector(
  selectMonetizationFeature,
  (state): PaywallInformation => ({
    description: state.storeSelectedProductDescription,
    name: state.storeSelectedProductName,
    priceText: state.storeSelectedProductPriceText,
    product: state.storeSelectedPurchasesStoreProduct,
    type: state.storeSelectedProductType,
    webPriceId: state.storeSelectedProductWebPriceId
  })
);

export const selectWebRedirectBackUrl = createSelector(selectMonetizationFeature, (state) => state.webRedirectBackUrl);

export const selectWebSubscriptionsList = createSelector(
  selectMonetizationFeature,
  (state) => state.webSubscriptionsList
);

export const selectStoreProducts = createSelector(selectMonetizationFeature, (state) => state.storeProducts);

export const selectStorePlatformProductIdentifiers = createSelector(
  selectMonetizationFeature,
  (state) => state.storePlatformProductIdentifiers
);

export const selectStoreSelectedProductInternalIdentifier = createSelector(
  selectMonetizationFeature,
  (state) => state.storeSelectedProductInternalIdentifier
);

export const selectPhoneAndEmailPurchasePreviewData = createSelector(selectMonetizationFeature, (state) => ({
  farmId: state.purchasePhoneAndEmailPreviewFarmId,
  propertyIds: state.purchasePhoneAndEmailPreviewPropertyIds
}));
